"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mixin Copyable to the BaseClass
 * @param BaseClass
 * @returns Copyable class
 * @example
 *
 * class A extends Copyable<Entity<EntityIdentifier>>{}
 *
 * @see https://github.com/Microsoft/TypeScript/issues/22431#issuecomment-371908767
 */
exports.Copyable = function (BaseClass) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * Return partial change of this object
         *
         * Example:
         * ```js
         * new Person({
         *   name "jack",
         *   age: 2
         * }).copy({age: 10})` is  `new Person({
         *   name: "jack",
         *   age: 10
         * })
         * ```
         */
        class_1.prototype.copy = function (partial) {
            var newProps = Object.assign({}, this.props, partial);
            var Construct = this.constructor;
            return new Construct(newProps);
        };
        /**
         * Return partial change of this object by using functions
         *
         * Example:
         * ```js
         * new Person({
         *   name "jack",
         *   age: 2
         * }).mapCopy({age: prev => prev+1})` is  `new Person({
         *   name: "jack",
         *   age: 3
         * })
         * ```
         */
        class_1.prototype.mapCopy = function (partial) {
            var newProps = {};
            var oldInstance = this;
            Object.keys(this.props).forEach(function (key) {
                if (key in partial) {
                    newProps[key] = partial[key](oldInstance[key]);
                }
                else {
                    newProps[key] = oldInstance[key];
                }
            });
            var Construct = this.constructor;
            return new Construct(newProps);
        };
        return class_1;
    }(BaseClass));
};
//# sourceMappingURL=Copyable.js.map